/**
 * The initial value of the @@toStringTag property is the String value "Set".
 * https://tc39.es/ecma262/#sec-set.prototype-@@tostringtag
 */
export const setPrototypeSymbolToStringTag = "Set";
